export default function Django_Home() {
  return <div>Django_Home Component</div>;
}
